import React, { useState } from 'react';
import { toast } from 'sonner';
import { Radar, Loader2, Upload, FileText, X } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { scoutQuickScan, apiError } from '../../services/scoutApi';

const FIELDS = [
  { key: 'email', label: 'Email', placeholder: 'priya.sharma@gmail.com', type: 'email' },
  { key: 'phone', label: 'Phone', placeholder: '+91 98450 12345' },
  { key: 'linkedin_url', label: 'LinkedIn', placeholder: 'linkedin.com/in/priya-sharma' },
  { key: 'github_url', label: 'GitHub (optional)', placeholder: 'github.com/priyasharma' },
  { key: 'location', label: 'Location', placeholder: 'Bengaluru, India' },
  { key: 'vendor', label: 'Vendor / source', placeholder: 'Acme Staffing' },
];
const EMPTY = { name: '', email: '', phone: '', linkedin_url: '', github_url: '', location: '', vendor: '' };

export const QuickCheckForm = ({ region, onStarted }) => {
  const [form, setForm] = useState(EMPTY);
  const [resume, setResume] = useState(null);
  const [busy, setBusy] = useState(false);
  const ready = form.name.trim().length >= 2 && (form.email.trim() || form.phone.trim() || form.linkedin_url.trim());

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => fd.append(k, v));
      if (region) fd.append('region', region);
      if (resume) fd.append('resume', resume);
      const r = await scoutQuickScan(fd);
      toast.success(`Scanning ${form.name}…`);
      setForm(EMPTY); setResume(null);
      onStarted?.(r.id);
    } catch (err) { toast.error(apiError(err, 'Could not start the scan')); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="rounded-2xl border bg-card p-5 space-y-4" data-testid="scout-quick-check-form">
      <div>
        <h3 className="text-sm font-bold flex items-center gap-2"><Radar className="h-4 w-4 text-primary" /> Quick check</h3>
        <p className="text-xs text-muted-foreground mt-1">Name plus any of email, phone or LinkedIn. Add a resume for timeline and duplicate checks.</p>
      </div>
      <div className="space-y-1">
        <label className="text-xs font-semibold text-muted-foreground">Full name *</label>
        <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Priya Sharma" data-testid="scout-input-name" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {FIELDS.map((f) => (
          <div key={f.key} className="space-y-1">
            <label className="text-xs font-semibold text-muted-foreground">{f.label}</label>
            <Input type={f.type || 'text'} value={form[f.key]} placeholder={f.placeholder} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} data-testid={`scout-input-${f.key}`} />
          </div>
        ))}
      </div>
      <label className="flex items-center gap-3 rounded-xl border border-dashed px-3 py-2.5 cursor-pointer hover:bg-muted/40 transition-colors" data-testid="scout-resume-dropzone">
        {resume ? <FileText className="h-4 w-4 text-primary" /> : <Upload className="h-4 w-4 text-muted-foreground" />}
        <span className="text-xs flex-1 truncate">{resume ? resume.name : 'Attach resume (PDF / DOCX) — optional'}</span>
        {resume && <button type="button" onClick={(e) => { e.preventDefault(); setResume(null); }} data-testid="scout-resume-clear"><X className="h-3.5 w-3.5" /></button>}
        <input type="file" accept=".pdf,.doc,.docx,.txt" className="hidden" onChange={(e) => setResume(e.target.files?.[0] || null)} data-testid="scout-resume-input" />
      </label>
      <Button type="submit" disabled={!ready || busy} className="w-full gap-2" data-testid="scout-run-scan-btn">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Radar className="h-4 w-4" />} Run Scout scan
      </Button>
    </form>
  );
};

export default QuickCheckForm;
